/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2TaskMyBoardsIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2TaskMyBoardsIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2TaskMyBoardsIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2TaskMyBoardsIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 14"
 style={{'--as-1-Z1H9UsK': alignSelf,'--mt-2-Z1H9UsK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1H9UsK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1H9UsK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1H9UsK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1H9UsK': opacity,'--w-10-Z1H9UsK': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1H9UsK': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1H9UsK': fill,'--a-7-Z1H9UsK': isAnimated ? animation : "none",'--sd-8-Z1H9UsK': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1H9UsK': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2TaskMyBoardsIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.25 0a1 1 0 00-1 1v.5a1 1 0 001 1h3a1 1 0 001-1V1a1 1 0 00-1-1h-3zM2 1h-.5A1.5 1.5 0 000 2.5v10A1.5 1.5 0 001.5 14H10a1.5 1.5 0 001.5-1.5v-10A1.5 1.5 0 0010 1h-.5v.5a2.25 2.25 0 01-2.25 2.25h-3A2.25 2.25 0 012 1.5V1zm6.7 4.9a.75.75 0 01.15 1.05l-3 4a.75.75 0 01-1.016.174l-1.5-1a.75.75 0 11.832-1.248l.91.606L7.65 6.05A.75.75 0 018.7 5.9z"
 style={{'--f-12-Z1H9UsK': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}